import { ReactElement } from 'react'

import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { ToolTip } from 'components/ToolTip'
import { enterImpersonationMode } from 'features/Auth/authService'
import { useAuthDomainValue } from 'hooks'

export function ImpersonationButtonToggle(): ReactElement | null {
    const isImpersonating = useAuthDomainValue('userIsImpersonating')

    const buttonText = `${
        isImpersonating ? 'Exit' : 'Enter'
    } Impersonation Mode`

    return (
        <>
            <Button
                type="link"
                onClick={() => {
                    // Rethrows after dispatching impersonationModeFailure;
                    // swallow here to avoid an unhandled promise rejection.
                    void enterImpersonationMode(!isImpersonating).catch(
                        () => {}
                    )
                }}
                className="p-0"
                style={{ height: 'auto' }}
            >
                {buttonText}
            </Button>
            {!isImpersonating && (
                <ToolTip
                    placement="top"
                    title={
                        <>
                            Impersonation Mode allows you to access any
                            organization and view customer data. Changes made to{' '}
                            <b>anything</b> in Impersonation Mode will be{' '}
                            <b>live in production</b>
                            .
                            <br />
                            Use extreme caution when making changes.
                        </>
                    }
                >
                    <QuestionCircleOutlined style={{ paddingLeft: 2 }} />
                </ToolTip>
            )}
        </>
    )
}
